import React from 'react'

const TextElement = (data) => {
  return (
    <p>{data.content}</p>
  )
}

export default TextElement